import React from 'react';
import './WhatIsGoloka.css';
import golokaImage from '../../goloka.png';
import eternalImage from '../../eternal.png';

function WhatIsGoloka() {
    return (
        <div className="what-is-goloka">
            <h1 className="page-title">🌟 What is Goloka Dham? 🌟</h1>

            <div className="intro-section">
                <p className="intro-text">
                    Goloka Dham (also known as Goloka Vrindavan) is the supreme spiritual abode,
                    the eternal residence of Lord Sri Krishna. It is the topmost planet in the
                    spiritual sky, where Krishna eternally engages in His most intimate and
                    blissful pastimes with His pure devotees.
                </p>
            </div>

            <div className="content-grid">
                <div className="info-card">
                    <div className="card-header">
                        <span className="card-icon">🏰</span>
                        <h2>The Supreme Abode</h2>
                    </div>
                    <div className="card-body">
                        <p>
                            Goloka Dham is described in the Brahma Samhita as the supreme planet,
                            full of spiritual gems and surrounded by millions of wish-fulfilling trees
                            (kalpa-vriksha). It is made entirely of touchstone (chintamani) and is
                            eternally illuminated by the spiritual effulgence of Lord Krishna.
                        </p>
                        <div className="image-container">
                            <img src={golokaImage}
                                alt="Spiritual Palace"
                                className="content-image" />
                        </div>
                    </div>
                </div>

                <div className="info-card">
                    <div className="card-header">
                        <span className="card-icon">💫</span>
                        <h2>Eternal Pastimes</h2>
                    </div>
                    <div className="card-body">
                        <p>
                            In Goloka Dham, Krishna performs His eternal pastimes (nitya-lila) as a
                            cowherd boy. He plays His flute, tends to cows, enjoys with His friends,
                            and engages in loving exchanges with the gopis (cowherd maidens) led by
                            Srimati Radharani.
                        </p>
                        <div className="image-container">
                            <img src={eternalImage}
                                alt="Krishna Playing Flute"
                                className="content-image" />
                        </div>
                    </div>
                </div>

                <div className="info-card">
                    <div className="card-header">
                        <span className="card-icon">🐄</span>
                        <h2>Land of Cows</h2>
                    </div>
                    <div className="card-body">
                        <p>
                            "Go-loka" literally means "the planet of cows." In this transcendental
                            land, Krishna tends to unlimited surabhi cows who yield unlimited milk.
                            Everything in Goloka serves the pleasure of Krishna and His devotees.
                        </p>
                        <div className="image-container">
                            <img src={golokaImage}
                                alt="Cows in Vrindavan"
                                className="content-image" />
                        </div>
                    </div>
                </div>

                <div className="info-card">
                    <div className="card-header">
                        <span className="card-icon">❤️</span>
                        <h2>Pure Love Divine</h2>
                    </div>
                    <div className="card-body">
                        <p>
                            In Goloka Dham, there is no anxiety, suffering, or material contamination.
                            The only emotion is pure transcendental love (prema) for Krishna. Every
                            resident serves Krishna in different relationships - as servants, friends,
                            parents, or beloved consorts.
                        </p>
                        <div className="image-container">
                            <img src={eternalImage}
                                alt="Krishna with Devotees"
                                className="content-image" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="scripture-section">
                <h2>📖 Scriptural References</h2>
                <div className="scripture-card">
                    <h3>Brahma Samhita (5.37)</h3>
                    <p className="sanskrit">
                        "ānanda-cinmaya-rasa-pratibhāvitābhis<br />
                        tābhir ya eva nija-rūpatayā kalābhiḥ<br />
                        goloka eva nivasaty akhilātma-bhūto<br />
                        govindam ādi-puruṣaṁ tam ahaṁ bhajāmi"
                    </p>
                    <p className="translation">
                        "I worship Govinda, the primeval Lord, who resides in His own realm,
                        Goloka, with Radha, who resembles His own spiritual figure and who
                        embodies the ecstatic potency of rasa."
                    </p>
                </div>

                <div className="scripture-card">
                    <h3>Bhagavad Gita (8.21)</h3>
                    <p className="sanskrit">
                        "avyakto 'kṣara ity uktas<br />
                        tam āhuḥ paramāṁ gatim<br />
                        yaṁ prāpya na nivartante<br />
                        tad dhāma paramaṁ mama"
                    </p>
                    <p className="translation">
                        "That supreme abode is called unmanifested and infallible, and it is
                        the supreme destination. When one goes there, he never comes back.
                        That is My supreme abode."
                    </p>
                </div>
            </div>

            <div className="qualities-section">
                <h2>✨ Unique Qualities of Goloka Dham</h2>
                <div className="qualities-grid">
                    <div className="quality-item">
                        <span className="quality-icon">♾️</span>
                        <h4>Eternal</h4>
                        <p>Never created, never destroyed - exists eternally beyond time</p>
                    </div>
                    <div className="quality-item">
                        <span className="quality-icon">🌅</span>
                        <h4>Self-Luminous</h4>
                        <p>Illuminated by Krishna's own spiritual effulgence</p>
                    </div>
                    <div className="quality-item">
                        <span className="quality-icon">💎</span>
                        <h4>Spiritual</h4>
                        <p>Made of pure spiritual energy, not material elements</p>
                    </div>
                    <div className="quality-item">
                        <span className="quality-icon">😊</span>
                        <h4>Blissful</h4>
                        <p>Full of ananda (spiritual bliss) at every moment</p>
                    </div>
                </div>
            </div>

            <div className="conclusion-section">
                <h2>🙏 Our Ultimate Destination</h2>
                <p>
                    According to ISKCON philosophy, the ultimate goal of human life is to
                    return to Goloka Dham and engage in eternal loving service to Lord Krishna.
                    This can be achieved through the practice of bhakti-yoga and sincere
                    devotional service. By following the nine processes of devotional service,
                    one can purify the heart and awaken dormant love for Krishna, ultimately
                    attaining the supreme destination of Goloka Dham.
                </p>
            </div>
        </div>
    );
}

export default WhatIsGoloka;
